import axios from 'axios';

const API_BASE_URL = 'https://venkatadrisevatrust.com/news_back_end_laravel/public/api/api/v1';

export const imagaeAPI = 'https://venkatadrisevatrust.com/news_back_end_laravel/public'





const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            const currentPath = window.location.pathname;
            // List of public routes that should NOT redirect
            const publicPaths = ['/', '/homepage', '/login'];
            if (!publicPaths.includes(currentPath)) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                window.location.href = '/homepage';
            }
            // If on a public route, just reject so the component can handle the error
        }
        console.error('API Error:', error.response?.data || error.message);
        return Promise.reject(error);
    }
);





export const photoAPI = {
    getAll: () => api.get('/photos'),
    create: (data) => api.post('/photos', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    update: (id, data) => api.post(`/photos/${id}?_method=PUT`, data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    delete: (id) => api.post(`/photosdelete/${id}`),

    toggleStatus: (id) => api.put(`/photos/${id}/toggle-status`)
};

export const videoAPI = {
    getAll: () => api.get('/videos'),
    create: (data) => api.post('/videos', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    update: (id, data) => api.post(`/videos/${id}?_method=PUT`, data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    delete: (id) => api.post(`/videosdelete/${id}`),

    toggleStatus: (id) => api.put(`/videos/${id}/toggle-status`)
};

export const dashboardAPI = {
    getCounts: () => api.get('/dashboard/counts')
};


export const contactAPI = {
    submit: (data) => api.post('/contact', data),
    // Admin methods (if needed)
    getAll: () => api.get('/contacts'),
    getOne: (id) => api.get(`/contacts/${id}`),
    delete: (id) => api.delete(`/contacts/${id}`),
    toggleRead: (id) => api.put(`/contacts/${id}/toggle-read`),
};


export const donationAPI = {
    getAll: () => api.get('/donations'),
    getOne: (id) => api.get(`/donations/${id}`),
    delete: (id) => api.delete(`/donations/${id}`),
};

export const roleAPI = {
    getAll: () => api.get('/roles'),
    getById: (id) => api.get(`/roles/${id}`),
    create: (data) => api.post('/roles', data),
    update: (id, data) => api.put(`/roles/${id}`, data),
    delete: (id) => api.delete(`/roles/${id}`),
    updateStatus: (id, status) => api.put(`/roles/${id}/status/${status}`),

};

export const authAPI = {
    login: (data) => api.post('/login', data),
    logout: () => api.post('/logout'),
    me: () => api.get('/me'),
    changePassword: (data) => api.post('/change-password', data),
    updateProfile: (data) => api.put('/update-profile', data)
};













export default api;